module.exports = __webpack_public_path__ + "img/i01_.725161f0.svg";